<template>
  <component :is="componentToRender" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PhaseSelector',
  computed: {
    ...mapGetters({
      activeAnimalType: 'animalType/getActiveAnimalType', // Getter to fetch the selected animal type
    }),
    componentToRender() {
      // Dynamically return the correct component based on the animal type
      return this.activeAnimalType.type === 'aqua'
        ? () => import('@/views/PhaseAqua') // Load PhaseAqua for Aqua animal type
        : () => import('@/views/Phase'); // Load Phase for other animal types
    },
  },
};
</script>
